"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationObject = void 0;
class ConfigurationObject {
    toObject() {
        return this.Value;
    }
}
exports.ConfigurationObject = ConfigurationObject;
//# sourceMappingURL=ConfigurationObject.js.map